export default {
  title: 'AUTO PACKAGING SETTINGS',
  items: {
    PackageDirectionAngle: {
      label: 'Maximum Bearing',
      type: 'integer',
      unit: 'degress (0-360)'
    },
    PackageDirectionDistance: {
      label: 'Max Distance from Pickup and Dropoff',
      type: 'integer',
      unit: 'miles (1-999)'
    },
    PackageSharedMaxPassengers: {
      label: 'Max Passengers',
      type: 'integer',
      unit: 'passengers'
    },
    PackageSharedMaxThresholdTime: {
      label: 'RSVP Inclusion Window',
      type: 'integer',
      unit: 'minutes'
    },
    PackageSharedMaxPickupThresholdTime: {
      label: 'Pickup Time Adjustment Window',
      type: 'integer',
      unit: 'minutes'
    }
  }
}




// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/auto-package-settings.js